import React from 'react'
import { parseWhatsapp } from '../../utilities/whatsappFormat'

// Desenha a mensagem com a formatação do WhatsApp (só elementos React: o texto nunca vira HTML)
function renderInline(nodes, prefix) {
  return nodes.map((node, index) => {
    const key = `${prefix}.${index}`
    if (node.type === 'bold') return <strong key={key}>{renderInline(node.children, key)}</strong>
    if (node.type === 'italic') return <em key={key}>{renderInline(node.children, key)}</em>
    if (node.type === 'strike') return <s key={key}>{renderInline(node.children, key)}</s>
    if (node.type === 'mono') return <span key={key} className='whatsapp-mono'>{node.text}</span>
    if (node.type === 'code') return <code key={key} className='whatsapp-code'>{node.text}</code>
    return <React.Fragment key={key}>{node.text}</React.Fragment>
  })
}

const renderLine = (children, key) => (children.length ? renderInline(children, key) : <br />)

const WhatsappText = ({ text }) => {
  const blocks = parseWhatsapp(text)

  return (
    <div className='whatsapp-text'>
      {blocks.map((block, index) => {
        const key = String(index)
        if (block.type === 'bullet') return (
          <ul key={key}>{block.items.map((item, i) => <li key={i}>{renderLine(item.children, `${key}.${i}`)}</li>)}</ul>
        )
        if (block.type === 'numbered') return (
          <ol key={key} start={block.items[0].number}>{block.items.map((item, i) => <li key={i} value={item.number}>{renderLine(item.children, `${key}.${i}`)}</li>)}</ol>
        )
        if (block.type === 'quote') return <blockquote key={key}>{renderLine(block.children, key)}</blockquote>
        return <div key={key}>{renderLine(block.children, key)}</div>
      })}
    </div>
  )
}

export default WhatsappText
